import { ExportToCsv } from 'export-to-csv';
const PortfolioToCsv = {
    save: async (portfolio, marketData) => {
        if(portfolio){
            return;
        }


        // Save positions
        const positionsArr = Object.keys(portfolio.positions).map(date => {
            const obj = portfolio.positions[date]
            obj.date = date;
            return obj
        });
        
        let csvExporter = new ExportToCsv({filename:"positions", useKeysAsHeaders:true});
        csvExporter.generateCsv(positionsArr);

        // Save returns
        const returnsArr = Object.keys(marketData.returnsMap).map(date => {
            const obj = marketData.returnsMap[date]
            obj.date = date;
            return obj
        }).filter(e => e.date !== '2016-06-07');
        
        csvExporter = new ExportToCsv({filename:"returns", useKeysAsHeaders:true});
        csvExporter.generateCsv(returnsArr);

        // Save position returns
        // const positionsReturnsArr = Object.keys(portfolio.returns).map(date => {
        //     const obj = portfolio.returns[date]
        //     obj.date = date;
        //     return obj
        // });
        
        // csvExporter = new ExportToCsv({filename:"position_returns"});
        // csvExporter.generateCsv(positionsReturnsArr);

        //Save quotas
        const quotas = portfolio.quotas()
        const quotasArr = Object.keys(quotas).map(date => {
            const val = quotas[date]
            return {date:date, quota:val}
        });
        
        csvExporter = new ExportToCsv({filename:"quotas", useKeysAsHeaders:true});
        csvExporter.generateCsv(quotasArr);
    }

}

export default PortfolioToCsv;